<!--==========================
=            TABS            =
===========================-->
<template>
  <!-- TABS -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Tabs</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">
            Tabs Playground
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div>
              <playground-tabs></playground-tabs>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- TABS -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Fixed tabs</div>
          <div slot="card-body">
            <div>
              <fixed-tabs></fixed-tabs>
            </div>
          </div>
        </base-card>
      </v-col>

      <!-- TABS -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Grow</div>
          <div slot="card-body">
            <div>
              <grow-tabs></grow-tabs>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- TABS -->

      <!-- TABS -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Vertical Tabs</div>
          <div slot="card-body">
            <div>
              <vertical-tabs></vertical-tabs>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- TABS -->
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Icons and text</div>
          <div slot="card-body">
            <div>
              <icons-tabs></icons-tabs>
            </div>
          </div>
        </base-card>
      </v-col>
      <!-- TABS -->
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
import VerticalTabs from "../../components/Ui/Tabs/VerticalTabs.vue";
import RightTabs from "../../components/Ui/Tabs/RightTabs.vue";
import PlaygroundTabs from "../../components/Ui/Tabs/PlaygroundTabs.vue";

import FixedTabs from "../../components/Ui/Tabs/FixedTabs.vue";
import GrowTabs from "../../components/Ui/Tabs/GrowTabs.vue";
import IconsTabs from "../../components/Ui/Tabs/IconsTabs.vue";
export default {
  components: {
    BaseCard,
    BaseHeader,
    RightTabs,
    PlaygroundTabs,    
    FixedTabs,
    GrowTabs,
    IconsTabs,
    VerticalTabs
  },

  data() {
    return {};
  }
};
</script>

<!--====  End of TABS  ====-->
